package pl.mothdigital.neuronowi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initChildProtectionStandardsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("ChildProtectionStandards.md", FrontMatterElement.EmptyMap))
}

@Page("/child-protection-standards")
@Composable
fun ChildProtectionStandardsPage() {
    pl.mothdigital.neuronowi.components.layouts.MarkdownLayout("Standardy Ochrony Małoletnich", "Standardy ochrony małoletnich w Centrum Terapii NeuroNowi zgodnie z ustawą Kamilka") {
        org.jetbrains.compose.web.dom.H1(attrs = { id("standardy-ochrony-małoletnich") }) {
            org.jetbrains.compose.web.dom.Text("Standardy Ochrony Małoletnich")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Zgodność z ustawą Kamilka")
            }
            org.jetbrains.compose.web.dom.Text(" (ustawa z 13 maja 2016 r. zmieniona ustawą z 2023 r.)")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data wejścia w życie:")
            }
            org.jetbrains.compose.web.dom.Text(" 15 lutego 2024 r.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Obowiązek wprowadzenia standardów:")
            }
            org.jetbrains.compose.web.dom.Text(" 15 sierpnia 2024 r.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Ostatnia aktualizacja:")
            }
            org.jetbrains.compose.web.dom.Text(" 9 maja 2025 r.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("wprowadzenie") }) {
            org.jetbrains.compose.web.dom.Text("Wprowadzenie")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Centrum Terapii NeuroNowi")
            }
            org.jetbrains.compose.web.dom.Text(" zobowiązuje się do przestrzegania standardów ochrony małoletnich zgodnie z przepisami prawa, których celem jest zapewnienie bezpieczeństwa dzieciom podczas zajęć terapeutycznych.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Dane placówki:")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Centrum Terapii NeuroNowi")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Fabryczna 17a/01, 65-410 Zielona Góra")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📧 ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📞 +48 500 124 500 | +48 600 234 002")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("1-polityka-i-zakres-stosowania") }) {
            org.jetbrains.compose.web.dom.Text("1. Polityka i zakres stosowania")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("zakres-stosowania") }) {
            org.jetbrains.compose.web.dom.Text("Zakres stosowania")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Standardy ochrony małoletnich obowiązują wszystkich:")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Pracowników")
                }
                org.jetbrains.compose.web.dom.Text(" Centrum Terapii NeuroNowi")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Wolontariuszy")
                }
                org.jetbrains.compose.web.dom.Text(" współpracujących z placówką")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Stażystów")
                }
                org.jetbrains.compose.web.dom.Text(" i praktykantów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Współpracowników")
                }
                org.jetbrains.compose.web.dom.Text(" i kontrahentów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Osoby trzecie")
                }
                org.jetbrains.compose.web.dom.Text(" przebywające na terenie placówki")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("organ-odpowiedzialny") }) {
            org.jetbrains.compose.web.dom.Text("Organ odpowiedzialny")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Osoba odpowiedzialna za standardy ochrony małoletnich:")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("Magdalena Nowik - Dyrektor Centrum Terapii NeuroNowi")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📧 ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📞 +48 500 124 500")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("2-rekrutacja-personelu") }) {
            org.jetbrains.compose.web.dom.Text("2. Rekrutacja personelu")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("obowiązkowe-sprawdzenia") }) {
            org.jetbrains.compose.web.dom.Text("Obowiązkowe sprawdzenia")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Każda osoba pracująca z dziećmi w naszym centrum musi przejść następujące sprawdzenia:")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Sprawdzenie w Rejestrze Sprawców Przestępstw Seksualnych")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Zaświadczenie o niekaralności")
                }
                org.jetbrains.compose.web.dom.Text(" z Krajowego Rejestru Karnego")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Oświadczenie o pobycie za granicą")
                }
                org.jetbrains.compose.web.dom.Text(" (w przypadku pobytu dłuższego niż 3 miesiące)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Sprawdzenie referencji")
                }
                org.jetbrains.compose.web.dom.Text(" i doświadczenia w pracy z dziećmi")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("dokumentowanie") }) {
            org.jetbrains.compose.web.dom.Text("Dokumentowanie")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Wszystkie dokumenty są przechowywane w aktach osobowych pracownika i podlegają regularnej weryfikacji.")
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("3-zasady-bezpiecznych-relacji") }) {
            org.jetbrains.compose.web.dom.Text("3. Zasady bezpiecznych relacji")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("zachowania-dozwolone") }) {
            org.jetbrains.compose.web.dom.Text("Zachowania dozwolone")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Kontakt fizyczny w celach terapeutycznych (za zgodą rodziców/opiekunów)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Komunikacja werbalna dostosowana do wieku dziecka")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wsparcie emocjonalne w ramach terapii")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Obecność rodziców/opiekunów podczas zajęć (na życzenie)")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("zachowania-niedozwolone") }) {
            org.jetbrains.compose.web.dom.Text("Zachowania niedozwolone")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Kontakt fizyczny bez uzasadnienia terapeutycznego")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Komunikacja prywatna z dzieckiem poza placówką")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Udostępnianie danych osobowych dziecka osobom nieuprawnionym")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Fotografowanie dziecka bez zgody rodziców/opiekunów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Kontakt w mediach społecznościowych z dziećmi")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("bezpieczny-kontakt-w-mediach-społecznościowych") }) {
            org.jetbrains.compose.web.dom.Text("Bezpieczny kontakt w mediach społecznościowych")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zakaz prywatnej komunikacji z dziećmi w mediach społecznościowych")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wszystkie kontakty zawodowe wyłącznie przez oficjalne kanały placówki")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zgłaszanie prób nieautoryzowanego kontaktu")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("4-interwencja-i-reakcja-na-podejrzenie-krzywdzenia") }) {
            org.jetbrains.compose.web.dom.Text("4. Interwencja i reakcja na podejrzenie krzywdzenia")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("obowiązek-zgłoszenia") }) {
            org.jetbrains.compose.web.dom.Text("Obowiązek zgłoszenia")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Każdy pracownik ma ")
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("obowiązek zgłoszenia")
            }
            org.jetbrains.compose.web.dom.Text(" podejrzenia krzywdzenia dziecka:")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Natychmiastowe sporządzenie notatki służbowej")
                }
                org.jetbrains.compose.web.dom.Text(" lub wysłanie maila")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Przekazanie zgłoszenia")
                }
                org.jetbrains.compose.web.dom.Text(" osobie odpowiedzialnej za standardy")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Powiadomienie dyrektora")
                }
                org.jetbrains.compose.web.dom.Text(" placówki")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("procedura-interwencji") }) {
            org.jetbrains.compose.web.dom.Text("Procedura interwencji")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("W przypadku podejrzenia krzywdzenia dziecka:")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Dokumentacja")
                }
                org.jetbrains.compose.web.dom.Text(" - sporządzenie szczegółowej notatki")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Kontakt z rodzicami/opiekunami")
                }
                org.jetbrains.compose.web.dom.Text(" prawnymi")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Powiadomienie sądu opiekuńczego")
                }
                org.jetbrains.compose.web.dom.Text(" (w razie potrzeby)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Zgłoszenie do odpowiednich służb")
                }
                org.jetbrains.compose.web.dom.Text(" (policja, prokuratura)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Procedura \"Niebieskiej Karty\"")
                }
                org.jetbrains.compose.web.dom.Text(" (w przypadku przemocy domowej)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Wewnętrzna interwencja")
                }
                org.jetbrains.compose.web.dom.Text(" - wsparcie dziecka i rodziny")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("5-dokumentacja-i-archiwizacja") }) {
            org.jetbrains.compose.web.dom.Text("5. Dokumentacja i archiwizacja")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("sposób-przechowywania") }) {
            org.jetbrains.compose.web.dom.Text("Sposób przechowywania")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wszystkie zgłoszenia przechowywane w ")
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("sejfie")
                }
                org.jetbrains.compose.web.dom.Text(" lub ")
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("zaszyfrowanym systemie")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dostęp wyłącznie dla osób uprawnionych")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dokumentacja przechowywana przez okres wymagany przepisami prawa")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("procedury-przeglądu") }) {
            org.jetbrains.compose.web.dom.Text("Procedury przeglądu")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Kwartalny przegląd")
                }
                org.jetbrains.compose.web.dom.Text(" dokumentacji")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Roczna aktualizacja")
                }
                org.jetbrains.compose.web.dom.Text(" standardów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Dokumentowanie")
                }
                org.jetbrains.compose.web.dom.Text(" wszystkich zmian i aktualizacji")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("6-szkolenia-i-przygotowanie-personelu") }) {
            org.jetbrains.compose.web.dom.Text("6. Szkolenia i przygotowanie personelu")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("kompetencje-osób-prowadzących-szkolenia") }) {
            org.jetbrains.compose.web.dom.Text("Kompetencje osób prowadzących szkolenia")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Szkolenia prowadzą:")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Certyfikowani trenerzy z zakresu ochrony małoletnich")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Specjaliści z Fundacji Dajemy Dzieciom Siłę")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Prawnicy specjalizujący się w prawie rodzinnym")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("zaplanowane-szkolenia") }) {
            org.jetbrains.compose.web.dom.Text("Zaplanowane szkolenia")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Szkolenie wstępne")
                }
                org.jetbrains.compose.web.dom.Text(" - dla nowych pracowników")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Szkolenie roczne")
                }
                org.jetbrains.compose.web.dom.Text(" - aktualizacja wiedzy")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Szkolenie specjalistyczne")
                }
                org.jetbrains.compose.web.dom.Text(" - rozpoznawanie symptomów krzywdzenia")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Szkolenie z procedur")
                }
                org.jetbrains.compose.web.dom.Text(" - reagowanie na incydenty")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("dokumentacja-szkoleń") }) {
            org.jetbrains.compose.web.dom.Text("Dokumentacja szkoleń")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Lista obecności")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Materiały szkoleniowe")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Test sprawdzający wiedzę")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Certyfikat ukończenia")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("7-edukacja-i-dostępność-informacji") }) {
            org.jetbrains.compose.web.dom.Text("7. Edukacja i dostępność informacji")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("informacje-dla-rodziców") }) {
            org.jetbrains.compose.web.dom.Text("Informacje dla rodziców")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Pełna wersja standardów dostępna na stronie internetowej")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Informacje wywieszone na tablicy ogłoszeń w placówce")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Broszury informacyjne dostępne w recepcji")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("informacje-dla-dzieci") }) {
            org.jetbrains.compose.web.dom.Text("Informacje dla dzieci")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Uproszczona wersja standardów dostosowana do wieku")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Informacje o prawach dziecka")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Kontakty do instytucji pomocowych")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("prawo-do-zgłoszenia") }) {
            org.jetbrains.compose.web.dom.Text("Prawo do zgłoszenia")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Każde dziecko ma prawo:")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zgłosić niepokojące zachowania")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poprosić o pomoc")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Skontaktować się z osobą odpowiedzialną za standardy")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("8-ochrona-wizerunku-i-danych-osobowych") }) {
            org.jetbrains.compose.web.dom.Text("8. Ochrona wizerunku i danych osobowych")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("zasady-fotografowania") }) {
            org.jetbrains.compose.web.dom.Text("Zasady fotografowania")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Zakaz fotografowania")
                }
                org.jetbrains.compose.web.dom.Text(" dzieci bez zgody rodziców/opiekunów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Pisemna zgoda")
                }
                org.jetbrains.compose.web.dom.Text(" na wykorzystanie wizerunku")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Określenie celu")
                }
                org.jetbrains.compose.web.dom.Text(" wykorzystania zdjęć")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Możliwość wycofania zgody")
                }
                org.jetbrains.compose.web.dom.Text(" w każdym czasie")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("ochrona-danych-osobowych") }) {
            org.jetbrains.compose.web.dom.Text("Ochrona danych osobowych")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zgodność z RODO")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Minimalizacja przetwarzanych danych")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Bezpieczne przechowywanie dokumentacji")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Prawa osób, których dane dotyczą")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("9-ochrona-w-internecie") }) {
            org.jetbrains.compose.web.dom.Text("9. Ochrona w Internecie")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("procedury-bezpieczeństwa") }) {
            org.jetbrains.compose.web.dom.Text("Procedury bezpieczeństwa")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Filtrowanie treści")
                }
                org.jetbrains.compose.web.dom.Text(" na urządzeniach placówki")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Monitoring")
                }
                org.jetbrains.compose.web.dom.Text(" aktywności online dzieci")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Edukacja")
                }
                org.jetbrains.compose.web.dom.Text(" w zakresie bezpieczeństwa internetowego")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("edukacja-dzieci") }) {
            org.jetbrains.compose.web.dom.Text("Edukacja dzieci")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Zasady bezpiecznego korzystania z internetu")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Rozpoznawanie zagrożeń online")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Procedury reagowania na niepokojące treści")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("10-plan-wsparcia-po-zdarzeniu") }) {
            org.jetbrains.compose.web.dom.Text("10. Plan wsparcia po zdarzeniu")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("procedura-wsparcia") }) {
            org.jetbrains.compose.web.dom.Text("Procedura wsparcia")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Po rozpoznaniu krzywdzenia dziecka:")
        }
        org.jetbrains.compose.web.dom.Ol {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Natychmiastowe zapewnienie bezpieczeństwa")
                }
                org.jetbrains.compose.web.dom.Text(" dziecku")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Kontakt z rodzicami/opiekunami")
                }
                org.jetbrains.compose.web.dom.Text(" prawnymi")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Współpraca z instytucjami pomocowymi")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Opracowanie indywidualnego planu wsparcia")
                }
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Monitorowanie")
                }
                org.jetbrains.compose.web.dom.Text(" sytuacji dziecka")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Wsparcie psychologiczne")
                }
                org.jetbrains.compose.web.dom.Text(" dla dziecka i rodziny")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("instytucje-współpracujące") }) {
            org.jetbrains.compose.web.dom.Text("Instytucje współpracujące")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Fundacja Dajemy Dzieciom Siłę")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Ośrodki pomocy społecznej")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Poradnie psychologiczno-pedagogiczne")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Policja i prokuratura")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("11-monitoring-i-ewaluacja") }) {
            org.jetbrains.compose.web.dom.Text("11. Monitoring i ewaluacja")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("odpowiedzialność-za-monitoring") }) {
            org.jetbrains.compose.web.dom.Text("Odpowiedzialność za monitoring")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Dyrektor placówki")
                }
                org.jetbrains.compose.web.dom.Text(" - nadzór ogólny")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Osoba odpowiedzialna za standardy")
                }
                org.jetbrains.compose.web.dom.Text(" - monitoring codzienny")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Zespół ds. bezpieczeństwa")
                }
                org.jetbrains.compose.web.dom.Text(" - przegląd kwartalny")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("cykliczność-przeglądów") }) {
            org.jetbrains.compose.web.dom.Text("Cykliczność przeglądów")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Przegląd miesięczny")
                }
                org.jetbrains.compose.web.dom.Text(" - dokumentacja incydentów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Przegląd kwartalny")
                }
                org.jetbrains.compose.web.dom.Text(" - efektywność procedur")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Przegląd roczny")
                }
                org.jetbrains.compose.web.dom.Text(" - aktualizacja standardów")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Przegląd dwuletni")
                }
                org.jetbrains.compose.web.dom.Text(" - kompleksowa ewaluacja")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("12-kontakt-i-wsparcie") }) {
            org.jetbrains.compose.web.dom.Text("12. Kontakt i wsparcie")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("osoby-do-kontaktu") }) {
            org.jetbrains.compose.web.dom.Text("Osoby do kontaktu")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Dyrektor Centrum:")
            }
            org.jetbrains.compose.web.dom.Text(" Magdalena Nowik")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📧 ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📞 +48 500 124 500")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Koordynator ochrony małoletnich:")
            }
            org.jetbrains.compose.web.dom.Text(" Magdalena Nowik")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📧 ")
            com.varabyte.kobweb.silk.components.navigation.Link("mailto:neuronowi.zg@gmail.com") {
                org.jetbrains.compose.web.dom.Text("neuronowi.zg@gmail.com")
            }
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.Text("📞 +48 500 124 500")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("instytucje-pomocowe") }) {
            org.jetbrains.compose.web.dom.Text("Instytucje pomocowe")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Fundacja Dajemy Dzieciom Siłę")
                }
                org.jetbrains.compose.web.dom.Text(" - 116 111 (Telefon Zaufania dla Dzieci i Młodzieży)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Niebieska Linia")
                }
                org.jetbrains.compose.web.dom.Text(" - 800 120 002 (Ogólnopolskie Pogotowie dla Ofiar Przemocy w Rodzinie)")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Policja")
                }
                org.jetbrains.compose.web.dom.Text(" - 997 lub 112")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Prokuratura")
                }
                org.jetbrains.compose.web.dom.Text(" - właściwa prokuratura rejonowa")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("infolinie-pomocowe") }) {
            org.jetbrains.compose.web.dom.Text("Infolinie pomocowe")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Telefon Zaufania dla Dzieci i Młodzieży:")
                }
                org.jetbrains.compose.web.dom.Text(" 116 111")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Telefon dla Rodziców i Nauczycieli:")
                }
                org.jetbrains.compose.web.dom.Text(" 800 100 100")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.B {
                    org.jetbrains.compose.web.dom.Text("Niebieska Linia:")
                }
                org.jetbrains.compose.web.dom.Text(" 800 120 002")
            }
        }
        org.jetbrains.compose.web.dom.H2(attrs = { id("13-materiały-do-pobrania") }) {
            org.jetbrains.compose.web.dom.Text("13. Materiały do pobrania")
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("dokumenty-dostępne-w-placówce") }) {
            org.jetbrains.compose.web.dom.Text("Dokumenty dostępne w placówce")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Pełny dokument standardów ochrony małoletnich")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Skrócona wersja dla dzieci")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Formularz zgłoszenia incydentu")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Wzór oświadczenia o niekaralności")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Procedura \"Niebieskiej Karty\"")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Dokumentacja szkolenia")
            }
        }
        org.jetbrains.compose.web.dom.H3(attrs = { id("dostępność-dokumentów") }) {
            org.jetbrains.compose.web.dom.Text("Dostępność dokumentów")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Wszystkie dokumenty dostępne są:")
        }
        org.jetbrains.compose.web.dom.Ul {
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("W recepcji placówki")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("Na stronie internetowej neuronowi.pl")
            }
            org.jetbrains.compose.web.dom.Li {
                org.jetbrains.compose.web.dom.Text("U osoby odpowiedzialnej za standardy")
            }
        }
        com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Data ostatniej aktualizacji:")
            }
            org.jetbrains.compose.web.dom.Text(" 9 maja 2025 r.")
            org.jetbrains.compose.web.dom.Br()
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Następna ewaluacja standardów:")
            }
            org.jetbrains.compose.web.dom.Text(" 9 maja 2026 r.")
        }
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Centrum Terapii NeuroNowi")
            }
            org.jetbrains.compose.web.dom.Text(" zobowiązuje się do przestrzegania wszystkich standardów ochrony małoletnich oraz do ciągłego doskonalenia procedur bezpieczeństwa w celu zapewnienia najwyższego poziomu ochrony dzieci.")
        }
    }
}
